export default "__VITE_ASSET__da0fe10e__"